<template>
  <div>
    <Head title="Create Asset Group" />
    <h1 class="mb-8 text-3xl font-bold">
      Inventaris
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/asset_groups">
        Asset Group
      </Link>
      <span class="text-indigo-400 font-medium"> / </span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pb-8 pr-6 w-1/2"
            label="Nama Group" />
          <select-input
            v-model="form.item_location_id"
            :error="form.errors.item_location_id"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Lokasi Item">
            <option
              v-for="itemLocation in itemLocations"
              :key="itemLocation.id"
              :value="itemLocation.id">
              {{ itemLocation.name }}
            </option>
          </select-input>
          <textarea-input
            rows="4"
            v-model="form.description"
            :error="form.errors.description"
            label="Deskripsi Asset Group"
            class="pb-8 pr-6 w-full md:w-1/2" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create Item Asset
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue'

export default {
    layout: Layout,
}
</script>

<script setup>
import { Head, Link, useForm } from '@inertiajs/vue3'
import { defineProps } from 'vue'
import TextInput from '@/Shared/TextInput.vue'
import SelectInput from '@/Shared/SelectInput.vue'
import TextareaInput from '@/Shared/TextareaInput.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'

const props = defineProps({
    itemLocations: Array,
    assetGroups: Object,
})

const form = useForm({
    ...props.assetGroups,
})

const store = () => {
    form.post('/asset_groups', {
        preserveScroll: true,
    })
}
</script>
